import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './PageStyle.css';
import ApiSender from '../common/ApiLogic';
import { v4 as uuidv4 } from 'uuid';

function PinPage() {

  const nav = useNavigate();
  const location = useLocation();
  const otpContainerRef = useRef();
  const [goalId, setGoalId] = useState(null);
  const [goalName, setGoalName] = useState(null);
  const [msisdn, setMsisdn] = useState(null);
  const [language, setLanguage] = useState('AR');
  const [warning, setWarning] = useState(false);
  const [isGradient, setIsGradient] = useState(false);
  const [otp, setOtp] = useState(null);
  const [firstStep, setFirstStep] = useState(true);
  const [secondStep, setSecondStep] = useState(false);
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  useEffect(() => {
    async function begin() {
      const landingPageUrl = window.location.origin + location.pathname;
      const apiSender = new ApiSender();
      apiSender.saveHistory(landingPageUrl, paramsObject);

      const goalInfoResult = await apiSender.getGoalsInfo(paramsObject);
      if (goalInfoResult.success) {
        const gi = goalInfoResult.goalId;
        const gn = goalInfoResult.goalName;
        setGoalId(gi);
        setGoalName(gn);
      }
    }
    begin();
  }, []);

  useEffect(() => {
    if (secondStep && otpContainerRef.current) {
      otpContainerRef.current.focus();
    }
  }, [secondStep]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      return;
    }
    setLanguage(lang.toUpperCase());
    setIsGradient(lang.toUpperCase() === 'EN' ? true : false);
  }, []);

  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang === 'English' ? 'EN' : 'AR');
    setIsGradient(selectedLang === 'English' ? true : false);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to right, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)'
      : 'linear-gradient(to left, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)',
  };

  const handleMsisdnChange = (event) => {
    const newMsisdn = event.target.value;
    setMsisdn(newMsisdn);
    document.getElementById('country-code').style.color = 'black';
    setWarning(false);
  }

  const handleMsisdnFocus = () => {
    document.getElementById('country-code').style.color = 'black';
  }

  const handleMsisdnBlur = () => {
    if (msisdn === null || msisdn === undefined || msisdn.length === 0) {
      document.getElementById('country-code').style.color = '#999';
    }
  }

  const handleOtpChange = (event) => {
    document.getElementById('otp-input').style.border = '';
    const newOtp = event.target.value;
    setOtp(newOtp);
  };

  const handleSendOtpClick = async () => {
    if (!isZain(msisdn)) {
      document.getElementById('warning-msg').textContent = language === 'EN' ? 'Incorrect Number Format' : 'رقم غير صحيح';
      setWarning(true);
      return;
    }

    document.getElementById('loading-spinner-send').style.display = 'inline-flex';
    document.getElementById('send-otp-btn').disabled = true;

    const apiSender = new ApiSender();
    const result = await apiSender.sendPin(msisdn, language, paramsObject);
    if (result.success) {
      document.getElementById('loading-spinner-send').style.display = 'none';
      document.getElementById('send-otp-btn').disabled = false;
      setWarning(false);
      setFirstStep(false);
      setSecondStep(true);
      document.getElementById('send-otp-btn').style.display = 'none';
      document.getElementById('verify-otp-btn').style.display = 'block';
      document.getElementById('msisdn-input').style.display = 'none';
      document.getElementById('otp-input-container').style.display = 'flex';
      document.getElementById('title').textContent = language === 'EN' ? 'Enter your OTP' : 'ادخل الرقم السري';
      return;
    }
    else {
      document.getElementById('loading-spinner-send').style.display = 'none';
      document.getElementById('send-otp-btn').disabled = false;
      setWarning(true);
      document.getElementById('warning-msg').textContent = result.message;
    }
  }

  const handleVerifyOtpClick = async () => {
    const o = otp;
    if (o === null || o === 'undefined' || (o.length !== 5)) {
      document.getElementById('otp-input').style.border = "2px solid rgb(103, 193, 98)";
      return;
    }

    document.getElementById('loading-spinner-verify').style.display = 'inline-flex';
    document.getElementById('verify-otp-btn').disabled = true;

    const landingPageUrl = window.location.origin + location.pathname;
    const otpId = uuidv4() + '-' + msisdn + '-' + new Date().getTime();
    const apiSender = new ApiSender();
    const result = await apiSender.verifyPin(msisdn, language, o, otpId, goalId, goalName, landingPageUrl, "Selfcare PowerPlay PIN Main LP", paramsObject);;
    if (result.success) {
      const userId = result.userId;
      const token = result.token;
      window.location.href = `http://iq.power-play.pro/ar` + (userId ? `?userId=${userId}` : "") + (token ? `&token=${token}` : "");
      document.getElementById('verify-otp-btn').disabled = false;
      document.getElementById('loading-spinner-verify').style.display = 'none';
      return;
    }
    else {
      document.getElementById('verify-otp-btn').disabled = false;
      document.getElementById('loading-spinner-verify').style.display = 'none';
      setWarning(true);
      setOtp('');
      document.getElementById('warning-msg').textContent = result.message;
    }
  }

  const isZain = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 13 && (msisdn.startsWith('96478') || msisdn.startsWith('96479')))
        || (msisdn.length === 10 && (msisdn.startsWith('78') || msisdn.startsWith('79')));
    }
    return false;
  }

  return (
    <div className="Aa000">
      <div className='container'>
        <div className='header'>
          <div className='header-left'>
            <div className="language" style={gradientStyle} onClick={handleLanguage}>
              <div className='language-left'>
                <span>عربي</span>
              </div>
              <div className='language-middle'>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              </div>
              <div className='language-right'>
                <span>English</span>
              </div>
            </div>
          </div>
          <div className='header-right'>
            <div className='logo'><img alt='PowerPlay' src='%PUBLIC_URL%/../../logo.png' /></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>{language === 'EN' ? 'Play over 200 games on your mobile device' : 'العب أكثر من 200 لعبة على هاتفك المحمول'}</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img alt='PowerPlay' src='%PUBLIC_URL%/../../banner_new.png' /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h4 id='title'>{secondStep ?
                (language === 'EN' ? 'Enter your OTP' : 'ادخل الرقم السري') :
                (language === 'EN' ? 'Enter your mobile number' : 'ادخل رقم هاتفك المحمول')}</h4>
            </div>
            <div className='arrows' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1.25rem' }}>
              {firstStep && <svg fill="#000000" height="2em" width="2em" viewBox="0 0 330 330" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"><path d="M15,180h263.787l-49.394,49.394c-5.858,5.857-5.858,15.355,0,21.213C232.322,253.535,236.161,255,240,255 s7.678-1.465,10.606-4.394l75-75c5.858-5.857,5.858-15.355,0-21.213l-75-75c-5.857-5.857-15.355-5.857-21.213,0 c-5.858,5.857-5.858,15.355,0,21.213L278.787,150H15c-8.284,0-15,6.716-15,15S6.716,180,15,180z" /></svg>}
              <div id='msisdn-input' className={`input ${warning ? 'vibrate' : ''}`}>
                <span id='country-code' className='country-code'>+964</span>
                <input type='tel' value={msisdn} placeholder='7x xxxx xxxx' autoComplete='off' minLength={10} maxLength={10} required onChange={handleMsisdnChange} onFocus={handleMsisdnFocus} onBlur={handleMsisdnBlur} />
                <div className='phone-logo'>
                  <img alt='' src='%PUBLIC_URL%/../../phone.png' />
                </div>
              </div>
              {firstStep && <svg fill="#000000" height="2em" width="2em" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 400.004 400.004" xmlSpace="preserve"><g><path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /></g></svg>}
            </div>
            <div id='warning-msg-div' className={`warning-msg ${warning ? 'active' : ''}`}>
              <span id='warning-msg'>{language === 'EN' ? 'Incorrect Number Format' : 'رقم غير صحيح'}</span>
            </div>
            <div id='otp-input-container' className='otp-input-container'>
              <input id='otp-input' type="tel" minLength={5} maxLength={5} value={otp} onChange={handleOtpChange} className="otp-input"
                autoComplete="off" ref={otpContainerRef} />
            </div>
            <div className='button'>
              <button id='send-otp-btn' style={{ display: 'block' }} onClick={handleSendOtpClick}>
                {language === 'EN' ? 'Subscribe' : 'اشترك'}
                <div id="loading-spinner-send" className="spinner"></div>
              </button>
              <button id='verify-otp-btn' style={{ display: 'none' }} onClick={handleVerifyOtpClick}>
                {language === 'EN' ? 'Subscribe' : 'اشترك'}
                <div id="loading-spinner-verify" className="spinner"></div>
              </button>
              <span>{language === 'EN' ? '' : ''}</span>
            </div>
          </div>
          <div className='form-content-bottom' style={{ direction: language === 'EN' ? "ltr" : "rtl" }}>
            {language === 'EN' ? (
              <span>
                Zain Subscribers will enjoy 1 day free trial. Service price is 240 IQD Daily. To unsubscribe send 020 to 4086
              </span>
            ) : (
              <span>
                سيحصل المستخدمون لأول مرة على تجربة مجانية ليوم واحد سعر الخدمة 240 IQD للرسالة المستلمة في اليوم. لإلغاء الإشتراك أرسل 020 الى 4086
              </span>
            )}
          </div>
          <div className='form-content-footer' style={{ direction: language === 'EN' ? "ltr" : "rtl" }}>
            <a href='#'><Link to={`/terms?lang=${language}`}>{language === 'AR' ? ('أحكام وشروط') : ('Terms and Condition')}</Link></a>
            <svg fill="#000000" width="1em" height="1em" viewBox="-6.5 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M8.469-1.156h2.25v29.813h-2.25v-29.813z"></path></svg>
            {language === 'AR' ? (<a href='mailto:support@power-play.pro'>للتواصل انقر هنا</a>) : (<a href='mailto:support@power-play.pro'>Contact Us</a>)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PinPage;
